<div class="dx-workflow-card bl-block-module">
    <div class="bl-margin-bottom--32" 
      [id]="card?.id"
      [attr.data-automation-id]="card?.automationId">
      <cu-card-review-header [flow]="flow" [card]="card" [page]="page" ></cu-card-review-header>
      <cu-card-review-fields [flow]="flow" [card]="card" [page]="page" ></cu-card-review-fields>
    </div>
</div>
